import { render, staticRenderFns } from "./PaymentStatusWidget.vue?vue&type=template&id=a9a61e6e&scoped=true&"
import script from "./PaymentStatusWidget.vue?vue&type=script&lang=ts&"
export * from "./PaymentStatusWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a61e6e",
  null
  
)

export default component.exports